import { useSearchParams, useNavigate } from "react-router-dom";
import { useEffect, useContext } from "react";
import { AuthContext } from '../context/AuthContext';

const AuthLand = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    // const { isSignedIn } = useAuth();
    const { user, loading } = useContext(AuthContext);

    const next = searchParams.get("next");

    useEffect(() => {
        // Wait for auth to finish loading
        if (loading) return;

        // If user is signed in, redirect to next or dashboard
        if (user) {
            const redirectUrl = next || '/dashboard';
            navigate(redirectUrl);
        } else {
            // If not signed in, redirect to sign-in page
            navigate('/auth/sign-in');
        }
    }, [user, loading, next, navigate]);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <p>Completing sign in...</p>
        </div>
    );
};

export default AuthLand;
